'use client'

import { EmailCapDrawerConnected } from 'components/EmailCapDrawer'
import { FooterConnected } from 'components/Footer_LEGACY'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'
import { HeaderConnected } from 'sections/Header/Header'

const CartLazy = dynamic(() => import('sections/Cart').then((module) => module.Cart), {
	ssr: false,
})

const BlogLayout = ({ children }: { children: React.ReactNode }) => {
	const ignoreEcap = true

	return (
		<>
			<Suspense fallback={null}>
				<HeaderConnected />
			</Suspense>

			<Suspense fallback={null}>
				<CartLazy />
			</Suspense>

			<div className={`root`}>{children}</div>

			{!ignoreEcap && <EmailCapDrawerConnected />}

			<Suspense fallback={null}>
				<FooterConnected />
			</Suspense>
		</>
	)
}

export default BlogLayout
